import { AmpPluginModule } from '../amp-plugin';
import { Subject } from 'rxjs';
import { akamai } from '../../globals';
import { AmpEventsState } from './amp-events-state';
import { debug } from '@medscape/streaming-video-player/src/js/utils/debug-log';
import { EVENT_READY } from './amp-events-sources.constants';
const AmpEventsKeys = Object.keys(akamai.amp.Events);
const AMP_EVENTS = AmpEventsKeys.map(eventKey => {
    return akamai.amp.Events[eventKey];
})
// const isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
const isiPhone = !!navigator.platform && /iPhone/.test(navigator.platform);
// const isiPad = !!navigator.platform &&  /iPad/.test(navigator.platform);
const { Map } = window;
const videoEvents = [
    "abort",
    "canplay",
    "canplaythrough",
    "durationchange",
    "emptied",
    "ended",
    "error",
    "loadeddata",
    "loadedmetadata",
    "loadstart",
    "pause",
    "play",
    "playing",
    "progress",
    "ratechange",
    "seeked",
    "seeking",
    "stalled",
    "suspend",
    "timeupdate",
    "volumechange",
    "waiting",
    "fullscreenchange",
    "mutechange"
]
export class AmpEventsSources extends AmpPluginModule {
    constructor(player, config, key) {
        super(player, config, key)
        this._sources = new Map();

        AMP_EVENTS.forEach(ampEvent => {
            if ((ampEvent in this) == false) {
                Object.defineProperty(this, ampEvent, {
                    get: () => {
                        return this.getSource(ampEvent);
                    }
                })
            }
        })

        

    }
    init() {
        debug.log("[AmpEventsSources] dispatch ready:",EVENT_READY )
        this.player.dispatcher.emit(EVENT_READY);
    }
    get isNativeControls() {
        return typeof(this.player.config.controls.native) !== 'undefined' && this.player.config.controls.native === true;
    }
    get sources() {
        return this._sources;
    }
    get captioningcuechange() {
        const eventName = "captioningcuechange";
        return this.getSource(eventName);
    }
    get cc_visibilitychange() {
        const eventName = "cc_visibilitychange";
        return this.getSource(eventName);
    }

    getEventData(e, player) {
        let metadata = player.media.metadata || {};
        metadata.videoId = metadata.videoId || "";

        let eventData = {
            event: e,
            target: e.target,
            type: e.type,
            amp: player,
            videoId: metadata.videoId,
            chapters: metadata.chapters || [],
            metadata: metadata,
            state: new AmpEventsState(player)
        }

        return eventData;
    }

    getSource(eventName, allowEvent = false) {
        let source = this.sources.get(eventName);

        if (source == null && (allowEvent || AMP_EVENTS.includes(eventName))) {
            source = new Subject();
            const isVideoEvent = videoEvents.includes(eventName);
            // iOS fullscreen will switch to native controls
            if (isVideoEvent && (isiPhone || this.isNativeControls)) {
                let { mediaElement } = this.player;
                if (eventName == "fullscreenchange") {
                    const onFullscreenchange = (e) => {
                        let eventData = this.getEventData(e, this.player);
                        eventData.state.isFullscreen = (mediaElement.webkitPresentationMode && mediaElement.webkitPresentationMode === "fullscreen") || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

                        source.next(eventData);
                    }
                    /* Standard syntax */
                    mediaElement.addEventListener("fullscreenchange", onFullscreenchange);

                    /* Firefox */
                    mediaElement.addEventListener("mozfullscreenchange", onFullscreenchange);

                    /* Chrome, Safari and Opera */
                    mediaElement.addEventListener("webkitfullscreenchange", onFullscreenchange);

                    /* IE / Edge */
                    mediaElement.addEventListener("msfullscreenchange", onFullscreenchange);

                    /* iOS */
                    mediaElement.addEventListener("webkitpresentationmodechanged", onFullscreenchange)
                } else if (eventName == "mutechange") {
                    let isMuted = mediaElement.muted;
                    mediaElement.addEventListener("volumechange", (e) => {
                        let eventData = this.getEventData(e, this.player);

                        eventData.state.isMuted = mediaElement.muted;
                        if (isMuted != eventData.state.isMuted) {
                            isMuted = eventData.state.isMuted;
                            source.next(eventData);
                        }


                    })
                } else {
                    if (eventName == "playing") {
                        debug.log("[AmpEventsSources] Add MediaElement Playing Event");
                    }
                    mediaElement.addEventListener(eventName, (e) => {
                        const { player } = this;
                        if (eventName == "playing") {
                            debug.log("[AmpEventsSources] MediaElement Event Playing:", e);
                        }

                        source.next(this.getEventData(e, player));

                    })
                }
            } else {
                // AMP Bug triggering playing event twice
                if (eventName == "playing") {
                    debug.log("[AmpEventsSources] Add AMP Playing Event");
                    this.player.mediaElement.addEventListener(eventName, (e) => {
                        debug.log("[AmpEventsSources] AMP Event:", eventName);
                        const { player } = this;
                        source.next(this.getEventData(e, player));
                    })
                } else {
                    this.player.addEventListener(eventName, (e) => {
                        const { player } = e;
                        if (eventName != "timeupdate") {
                            debug.log("[AmpEventsSources] AMP Event:", eventName);
                        }
                        source.next(this.getEventData(e, player));

                    })
                }
            }

        } else if (source == null && eventName == "cc_visibilitychange" && this.player.captioning) {
            source = new Subject();
            this.player.captioning?.addEventListener("visibilitychange", event => {
                const { player } = event;
                source.next(this.getEventData(event, player));
            });


        } else if (source == null && eventName == "captioningcuechange" && this.player.captioning) {
            source = new Subject();
            
            this.player.captioning?.addEventListener("cuechange", event => {
                const { player } = event;
                source.next(this.getEventData(event, player));
            });

        }

        if (source != null) {
            this.sources.set(eventName, source);
        }
        return source;
    }

}